import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { AspectRatioWrapper, CookieBlockedIframe } from '../../../../components/index.js';
import css from './YoutubeEmbed.module.css';

const RADIX = 10;
const BLACK_BG = '#000000';


export const YoutubeEmbed = props => {
  const { className, rootClassName, youtubeVideoId, aspectRatio = '16/9' } = props;
  const hasSlash = aspectRatio.indexOf('/') > 0;
  const [aspectWidth, aspectHeight] = hasSlash ? aspectRatio.split('/') : [16, 9];
  const width = Number.parseInt(aspectWidth, RADIX);
  const height = Number.parseInt(aspectHeight, RADIX);
  const classes = classNames(rootClassName || css.video, className);

  return (
    <AspectRatioWrapper className={classes} width={width} height={height}>
      <CookieBlockedIframe
        src={`https://www.youtube-nocookie.com/embed/${youtubeVideoId}`}
        service="youtube"
        className={css.iframe}
        style={{ background: BLACK_BG }}
      />
    </AspectRatioWrapper>
  );
};

YoutubeEmbed.displayName = 'YoutubeEmbed';

YoutubeEmbed.propTypes = {
  rootClassName: string,
  className: string,
  youtubeVideoId: string.isRequired,
  aspectRatio: string,
};
